import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Tabs, Chip, Modal, Person, img, fmt, when } from "./kit";

const statusChip = (s) =>
  ({
    pending: <Chip kind="wait">Başvuru</Chip>,
    active: <Chip>Aktif</Chip>,
    rejected: <Chip kind="bad">Reddedildi</Chip>,
    banned: <Chip kind="bad">Askıda</Chip>,
  }[s] || s);

const Agencies = () => {
  const [tab, setTab] = useState("pending");
  const [q, setQ] = useState("");
  const [data, setData] = useState({ agencies: [], counts: {}, pendingPayouts: 0 });
  const [payouts, setPayouts] = useState([]);
  const [detail, setDetail] = useState(null);
  const [managers, setManagers] = useState(null);

  const load = useCallback(async () => {
    if (tab === "payouts") {
      const r = await api.agencyPayouts({});
      if (r?.status) setPayouts(r.payouts);
      const l = await api.agencies({});
      if (l?.status) setData(l);
      return;
    }
    const r = await api.agencies({ status: tab === "all" ? "" : tab, q });
    if (r?.status) setData(r);
  }, [tab, q]);

  useEffect(() => {
    load();
  }, [load]);

  // Super Admin listesi (panel hesaplari + uygulamadaki Super Admin kullanicilari); yetki yoksa null kalir
  useEffect(() => {
    api
      .agencyManagers()
      .then((r) => r?.status && setManagers(r.managers || []))
      .catch(() => {});
  }, []);

  const openDetail = async (a) => {
    const r = await api.agency(a._id);
    if (r?.status) setDetail(r);
  };

  const act = async (a, action, extra = {}) => {
    const r = await api.agencyAction(a._id, { action, ...extra });
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız");
    load();
    if (r.deleted) return setDetail(null);
    if (detail) openDetail(a);
  };

  // Super Admin kendi ajanslarindaki kisileri engelleyebilir (sunucu kontrol eder)
  const engelle = async (hostId, blokta) => {
    let reason = "";
    if (!blokta) {
      reason = window.prompt("Engelleme sebebi (en az 3 karakter):", "");
      if (reason === null) return;
    } else if (!window.confirm("Engel kaldırılsın mı?")) return;
    const r = await api.agencyBan({ targetId: hostId, reason, unblock: blokta });
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız");
    if (detail) openDetail(detail.agency);
  };

  const sil = (a) => {
    const yazi = window.prompt(`"${a.name}" ajansı kalıcı olarak silinecek. Yayıncıları serbest kalır.\nOnaylamak için ajans adını yaz:`, "");
    if (yazi === null) return;
    if (yazi.trim() !== a.name.trim()) return window.alert("Ad eşleşmedi, silinmedi.");
    act(a, "delete");
  };

  const reject = (a) => {
    const reason = window.prompt("Red sebebi (başvurana gösterilir):", "");
    if (reason !== null) act(a, "reject", { reason });
  };

  const commission = (a) => {
    const v = window.prompt("Komisyon yüzdesi (0-50):", a.commissionPercent);
    if (v !== null) act(a, "commission", { commissionPercent: Number(v) });
  };

  const payoutAct = async (p, action) => {
    const note = window.prompt(action === "paid" ? "Ödeme notu (dekont no vb.):" : "Red sebebi (tutar bakiyeye geri döner):", "");
    if (note === null) return;
    const r = await api.agencyPayoutAction(p._id, { action, note });
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız");
    load();
  };

  const c = data.counts || {};
  return (
    <>
      <PageHead title="Ajanslar" sub="Ajans başvurularını onayla, komisyon oranını belirle, yayıncı ekle/çıkar ve ödeme taleplerini yönet. Komisyon platform tarafından ödenir; yayıncının kazancından kesilmez." />
      <Tiles
        items={[
          { label: "Bekleyen başvuru", value: fmt(c.pending) },
          { label: "Aktif ajans", value: fmt(c.active) },
          { label: "Bekleyen ödeme", value: fmt(data.pendingPayouts) },
          { label: "Toplam ajans bakiyesi", value: fmt((data.agencies || []).reduce((s, a) => s + (a.balance || 0), 0)) },
          { label: "Toplam yayıncı elması", value: fmt(data.totalHostDiamond) },
        ]}
      />
      <div className="d-flex justify-content-between align-items-center" style={{ gap: 10, flexWrap: "wrap" }}>
        <Tabs
          value={tab}
          onChange={setTab}
          tabs={[
            ["pending", "Başvurular"],
            ["active", "Aktif"],
            ["banned", "Askıda"],
            ["rejected", "Reddedilen"],
            ["all", "Tümü"],
            ["payouts", "Ödeme talepleri"],
          ]}
        />
        {tab !== "payouts" && (
          <input className="form-control" style={{ maxWidth: 240, marginBottom: 12 }} placeholder="Ad ya da ajans kodu" value={q} onChange={(e) => setQ(e.target.value)} />
        )}
      </div>

      {tab === "payouts" ? (
        <Table
          head={["Ajans", "Coin", "Yöntem", "Hesap", "Durum", "Tarih", ""]}
          empty="Ödeme talebi yok."
          rows={payouts.map((p) => (
            <tr key={p._id}>
              <td>
                <b>{p.agencyName}</b>
              </td>
              <td>{fmt(p.coin)}</td>
              <td>{p.method}</td>
              <td style={{ fontSize: 12 }}>
                <code>{p.account}</code>
              </td>
              <td>{p.state === "paid" ? <Chip>Ödendi</Chip> : p.state === "rejected" ? <Chip kind="bad">Reddedildi</Chip> : <Chip kind="wait">Bekliyor</Chip>}</td>
              <td>{when(p.createdAt)}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                {p.state === "pending" && (
                  <>
                    <button className="btn btn-sm btn-success" onClick={() => payoutAct(p, "paid")}>
                      Ödendi
                    </button>{" "}
                    <button className="btn btn-sm btn-outline-danger" onClick={() => payoutAct(p, "reject")}>
                      Reddet
                    </button>
                  </>
                )}
                {p.adminNote ? <div style={{ fontSize: 11, color: "#6B7280" }}>{p.adminNote}</div> : null}
              </td>
            </tr>
          ))}
        />
      ) : (
        <Table
          head={["Ajans", "Sahip", "Super Admin", "Kod", "Yayıncı", "Komisyon", "Toplam komisyon", "Bakiye", "Yayıncı elması", "Durum", ""]}
          empty="Kayıt yok."
          rows={(data.agencies || []).map((a) => (
            <tr key={a._id}>
              <td>
                <Person image={a.logo} name={a.name} />
                {a.status === "pending" && a.note ? <div style={{ fontSize: 12, color: "#6B7280", maxWidth: 260 }}>{a.note}</div> : null}
              </td>
              <td>
                {a.ownerName}
                <div style={{ fontSize: 11, color: "#6B7280" }}>{a.contact}</div>
              </td>
              <td>
                {managers ? (
                  <select
                    value={a.managerId || ""}
                    onChange={(e) => act(a, "assignManager", { managerId: e.target.value })}
                    style={{ maxWidth: 190, padding: "5px 6px", borderRadius: 8, border: "1px solid #D1D5DB", fontSize: 12.5, background: a.managerId ? "#EEF4FF" : "#fff" }}
                  >
                    <option value="">— Atanmamış —</option>
                    {managers.map((m) => (
                      <option key={m._id} value={m._id}>
                        {m.name}
                      </option>
                    ))}
                    {a.managerId && !managers.some((m) => String(m._id) === String(a.managerId)) ? <option value={a.managerId}>(bilinmeyen hesap)</option> : null}
                  </select>
                ) : a.managerId ? (
                  <Chip>Atanmış</Chip>
                ) : (
                  "—"
                )}
              </td>
              <td>
                <code>{a.code}</code>
              </td>
              <td>{a.hostCount}</td>
              <td>%{a.commissionPercent}</td>
              <td>{fmt(a.totalCommission)}</td>
              <td>{fmt(a.balance)}</td>
              <td><b>{fmt(a.hostDiamond)}</b></td>
              <td>{statusChip(a.status)}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                {a.status === "pending" && (
                  <>
                    <button className="btn btn-sm btn-success" onClick={() => act(a, "approve")}>
                      Onayla
                    </button>{" "}
                    <button className="btn btn-sm btn-outline-danger" onClick={() => reject(a)}>
                      Reddet
                    </button>{" "}
                  </>
                )}
                {a.status !== "pending" && (
                  <button className="btn btn-sm btn-outline-primary" onClick={() => openDetail(a)}>
                    Detay
                  </button>
                )}{" "}
                {a.status === "active" && (
                  <>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => commission(a)}>
                      Komisyon
                    </button>{" "}
                    <button className="btn btn-sm btn-outline-warning" onClick={() => act(a, "ban")}>
                      Askıya al
                    </button>
                  </>
                )}
                {a.status === "banned" && (
                  <button className="btn btn-sm btn-outline-success" onClick={() => act(a, "unban")}>
                    Aktif et
                  </button>
                )}
              </td>
            </tr>
          ))}
        />
      )}

      <Modal open={!!detail} wide title={detail?.agency?.name || "Ajans"} onClose={() => setDetail(null)}>
        {detail && (
          <>
            <div className="d-flex align-items-center" style={{ gap: 12, marginBottom: 12 }}>
              {detail.agency.logo ? <img src={img(detail.agency.logo)} alt="" style={{ width: 56, height: 56, borderRadius: 28, objectFit: "cover" }} /> : null}
              <div>
                <div>
                  Sahip: <b>{detail.agency.ownerName}</b> · Kod <code>{detail.agency.code}</code> · %{detail.agency.commissionPercent} komisyon
                </div>
                <div style={{ fontSize: 12, color: "#6B7280" }}>
                  Yayıncı kazancı {fmt(detail.agency.totalHostEarn)} · Komisyon {fmt(detail.agency.totalCommission)} · Bakiye {fmt(detail.agency.balance)} · Yayıncı elması <b>{fmt(detail.agency.hostDiamond)}</b>
                </div>
              </div>
            </div>
            <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
              <button className="btn btn-sm btn-outline-primary" onClick={() => { const code = window.prompt("Eklenecek yayıncının kullanıcı kodu ya da ID'si:"); if (code) act(detail.agency, "addHost", { hostCode: code }); }}>
                Yayıncı ekle
              </button>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => { const n = window.prompt("Yeni ajans adı:", detail.agency.name); if (n) act(detail.agency, "rename", { name: n }); }}>
                Adını değiştir
              </button>
              <button className="btn btn-sm btn-outline-secondary" onClick={() => { const d = window.prompt("Bakiyeye eklenecek (+) ya da düşülecek (-) coin:"); if (d) act(detail.agency, "adjustBalance", { delta: Number(d) }); }}>
                Bakiye düzelt
              </button>
              <button className="btn btn-sm btn-outline-danger" style={{ marginLeft: "auto" }} onClick={() => sil(detail.agency)}>
                Ajansı sil
              </button>
            </div>
            <h6>Asistanlar</h6>
            <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 6 }}>
              Asistan yalnızca yayıncı isteklerini kabul eder ya da reddeder. Para, çekim, yayıncı çıkarma ve ajans ayarlarına erişemez; komisyon almaz.
            </div>
            <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 14 }}>
              {(detail.partners || []).map((p) => (
                <span key={p._id} className="d-inline-flex" style={{ alignItems: "center", gap: 6, padding: "4px 6px 4px 4px", borderRadius: 20, background: "#EEF2FF" }}>
                  {p.image ? <img src={img(p.image)} alt="" style={{ width: 24, height: 24, borderRadius: 12, objectFit: "cover" }} /> : null}
                  <b style={{ fontSize: 13 }}>{p.name || "—"}</b>
                  <span style={{ fontSize: 12, color: "#6B7280" }}>ID {p.uniqueID}</span>
                  <button
                    className="btn btn-sm btn-link text-danger"
                    style={{ padding: "0 4px" }}
                    onClick={() => window.confirm(`${p.name} asistanlıktan çıkarılsın mı?`) && act(detail.agency, "removePartner", { partnerId: p._id })}
                  >
                    ✕
                  </button>
                </span>
              ))}
              {!(detail.partners || []).length && <span style={{ fontSize: 13, color: "#9CA3AF" }}>Asistan yok</span>}
              <button className="btn btn-sm btn-outline-primary" onClick={() => { const code = window.prompt("Asistan olarak eklenecek kişinin kullanıcı ID'si:"); if (code) act(detail.agency, "addPartner", { code }); }}>
                + Asistan ekle
              </button>
            </div>
            <h6>Yayıncılar</h6>
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Yayıncı</th>
                  <th>Durum</th>
                  <th>Elmas</th>
                  <th>Toplam kazanç</th>
                  <th>Katılma</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {detail.members.map((m) => (
                  <tr key={m._id}>
                    <td>
                      <Person image={m.hostImage} name={m.hostName} />
                      {m.uniqueID ? <div style={{ fontSize: 11, color: "#6B7280" }}>ID {m.uniqueID}</div> : null}
                    </td>
                    <td>
                      {m.isBlock ? <Chip kind="bad">Engelli</Chip> : m.state === "active" ? <Chip>Aktif</Chip> : <Chip kind="wait">İstek</Chip>}
                    </td>
                    <td><b>{fmt(m.diamond)}</b></td>
                    <td>{fmt(m.totalEarn)}</td>
                    <td>{when(m.joinedAt || m.createdAt)}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-secondary" style={{ marginInlineEnd: 6 }} onClick={() => engelle(m.hostId, !!m.isBlock)}>
                        {m.isBlock ? "Engeli kaldır" : "Engelle"}
                      </button>
                      <button className="btn btn-sm btn-outline-danger" onClick={() => act(detail.agency, "removeHost", { hostId: m.hostId })}>
                        Çıkar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <h6>Son komisyon kayıtları</h6>
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Kaynak</th>
                  <th>Yayıncı kazancı</th>
                  <th>Komisyon</th>
                  <th>Tarih</th>
                </tr>
              </thead>
              <tbody>
                {detail.earnings.map((e) => (
                  <tr key={e._id}>
                    <td>{{ live_gift: "Canlı hediye", room_gift: "Oda hediyesi", pk_gift: "PK hediyesi", video_call: "Görüntülü arama" }[e.source] || e.source}</td>
                    <td>{fmt(e.hostCoin)}</td>
                    <td>{fmt(e.commission)}</td>
                    <td>{when(e.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </Modal>
    </>
  );
};

export default Agencies;
